import React from "react"
import Popper from '@mui/material/Popper'
import PropTypes from 'prop-types'

const CustomPopper = ({ anchorEl, ...props }) => (
    <Popper
        {...props}
        anchorEl={anchorEl}
        disablePortal={false}
        style={{
            zIndex: 2000,
            width: anchorEl ? anchorEl.clientWidth : undefined,
        }}
    />
)

CustomPopper.propTypes = {
    anchorEl: PropTypes.any,
    style: PropTypes.object,
}

export default CustomPopper